export const SITE_RAP_PRIMARY_LOAD_TYPES = [
    'Chillers',
    'Compressors',
    'HVAC',
    'Lighting',
    'Large Equipment',
    'Motors',
    'Pumping',
    'Refrigeration',
    'Processes',
    'Backup Generation',
];

export const SITE_RAP_PARTICIPATION_TYPES = ['Manual', 'Auto-DR'];

export const SITE_RAP_REDUCTION_TYPES = ['Full', 'Partial'];

export const SITE_RAPS_CSV_CONFIG = [
    {
        column: 'Site ID*',
        required: true,
        description: 'Automatically populated from DRMS - DO NOT CHANGE',
        width: 100,
    },
    {
        column: 'Site Name*',
        required: true,
        description: 'Automatically populated from DRMS - DO NOT CHANGE',
        width: 150,
    },
    {
        column: 'Site Address*',
        required: true,
        description: 'Automatically populated from DRMS - DO NOT CHANGE',
        width: 150,
    },
    {
        column: 'Site Status*',
        required: true,
        description: 'Automatically populated from DRMS - DO NOT CHANGE',
        width: 100,
    },

    {
        column: 'Participation Type',
        required: false,
        description: 'Manual or Auto-DR',
        width: 120,
    },
    {
        column: 'Reduction Type',
        required: false,
        description: 'Full or Partial',
        width: 120,
    },
    {
        column: 'Primary Load Type',
        required: false,
        description: `${SITE_RAP_PRIMARY_LOAD_TYPES.join(', ')}`,
        width: 150,
    },
    {
        column: 'Curtailment Strategy',
        required: false,
        description: 'Curtailment strategy description',
        width: 200,
    },
    {
        column: 'Reduction Action Plan',
        required: false,
        description: 'Describe the actions that will be taken to reduce load during a DR event',
        width: 300,
    },
    {
        column: 'Source',
        required: false,
        description:
            'Import or Salesforce (Only informational column, Salesforce has priority over import, and if salesforce data is present, this record data will not be updated)',
        width: 300,
    },
];

export type SiteRapsCsvColumns = (typeof SITE_RAPS_CSV_CONFIG)[number]['column'];
